// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__DdJZ-","bigColWidth":"Table_bigColWidth__35y90","biggerColWidth":"Table_biggerColWidth__HRdmT","row":"Table_row__aZdMm","col":"Table_col__1iR2q"};